_ = require 'underscore'
CustomFieldCardDetailBadgeView = require 'app/scripts/views/custom-field/custom-field-card-detail-badge-view'
t = require('app/scripts/views/internal/teacup-with-helpers')()
Util = require 'app/scripts/lib/util'

module.exports = class CustomFieldCheckboxCardDetailBadgeView extends CustomFieldCardDetailBadgeView
  template: t.renderable ({ icon, name, text, editable, color } = {}) ->
    t.h3 '.card-detail-item-header', { title: name }, ->
      t.icon icon, { class: "mod-quiet" }
      t.text name

    t.span '.custom-field-detail-badge.custom-field-detail-checkbox-badge' + color,
      {
        class: t.classify({
          'js-custom-field-detail-badge': editable
          'is-clickable': editable
          'is-checked': @isChecked()
        })
      }
      , ->
        t.span '.custom-field-detail-badge-checkbox-box', ->
          t.span '.icon-sm.icon-check.custom-field-detail-badge-checkbox-icon'

  isChecked: ->
    @customFieldItem?.get('value')?.checked == 'true'

  getBadgeText: ->
    @customField.get('name')

  events:
    'click .js-custom-field-detail-badge': 'editCustomFieldBadge'

  editCustomFieldBadge: (e) ->
    Util.stop(e)
    @track()

    if !@customFieldItem?
      @model.customFieldItemList.create({
        idCustomField: @customField.id
        idModel: @model.id
        modelType: 'card'
        value:
          checked: 'true'
      })
      return

    newVal = !@customFieldItem.getParsedValue()
    if newVal
      @customFieldItem.setValue({ checked: newVal.toString() })
    else
      @customFieldItem.clearValue()
